import { useState } from 'react';
import type * as React from 'react';

export function useModalToggle(
  initial = false
): [boolean, React.Dispatch<React.SetStateAction<void>>] {
  const [visible, setVisible] = useState(initial);

  function toggleVisible() {
    setVisible(v => !v);
  }

  return [visible, toggleVisible];
}
